const getters = {
    menus:state=>state.user.menus,
    token:state=>state.user.token,
    hostConfig:state=>JSON.parse(state.user.hostConfig),
}
export default getters